<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma oferta ou código" v-model="searchText"
                      style="max-width: 400px"
                      class="rounded-card"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    searchText: {
      get() {
        return this.$store.getters['listagemMarketplaceOfertas/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemMarketplaceOfertas/searchText', searchText);
      },
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.marketplace.ofertas' });
    },
    onClickRefresh() {
      this.$emit('refresh');
    },
    onChangeSearchText() {
      this.$emit('change');
    },
  },
};
</script>
